import { toast } from 'react-toastify';

export function paddImage(imageUrl: string, padding: number = 50) {
  return new Promise<Blob>((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Handle CORS if needed
    img.src = imageUrl;

    img.onload = () => {
      // Create a canvas element
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // Set canvas size (image width + padding on both sides)
      canvas.width = img.width + padding * 2;
      canvas.height = img.height + padding * 2;

      // Draw the image onto the canvas with padding
      context!.fillStyle = 'transparent'; // Background color (optional)
      context!.fillRect(0, 0, canvas.width, canvas.height); // Fill canvas with background color
      context!.drawImage(img, padding, padding); // Draw image with padding

      // Convert canvas to Blob
      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          // Handle error in creating Blob
          toast.error('Failed to create Blob from canvas');
          resolve(undefined as any);
        }
      }, 'image/png'); // Specify MIME type for the Blob
    };
  });
}
